export const BASE_URL = import.meta.env.VITE_API_BASE_URL

export const BRIDGE_BASE_URL = import.meta.env.VITE_BRIDGE_BASE_URL
export const BRIDGE_API_KEY = import.meta.env.VITE_BRIDGE_API_KEY
